<div class="container_filter">
  <div class="header">
    <div class="title-description">
      <h2 class="filter-title">
        {{ "companies.filter.title" | translate }}
      </h2>
      <p class="filter-description">
        {{ "filter.description" | translate }}
      </p>
    </div>
    <button class="close" (click)="close()">
      <img src="assets/icones/close.svg" alt="" />
    </button>
  </div>

  <div class="content">
    <div class="selection">
      <div class="import-and-selected">
        <ng-container *ngIf="companyFilters?.filters?.length > 0">
          <button class="select-saved-filter" [matMenuTriggerFor]="menu">
            <img src="assets/icones/import-filter.svg" alt="" />
            <small>{{ "filter.import" | translate }}</small>
          </button>
          <mat-menu #menu="matMenu" class="import-menu">
            <div class="filter_btn"
              *ngFor="let filter of companyFilters?.filters || []"

            >
              <span (click)="setFilter(filter)"
              >{{ filter.name }}</span>
              <button (click)="deleteFilter(filter)" >
                <img src="assets/icones/delete_btn.svg" alt="">
              </button>
            </div>
          </mat-menu>
        </ng-container>
        <div class="applied-filters-count" (click)="clearFilters()">
          <span class="count">{{ getFiltersCount() }}</span>
          <span>{{ "filter.applied" | translate }}</span>
          <img src="assets/icones/clear-filter.svg" alt="" />
        </div>
      </div>
      <div
        *ngIf="!isLocation"
        class="filter-group"
        [class.filter-group-selected]="selectedGroup === 'company_info'"
      >
        <div class="group-title" (click)="selectedGroup = 'company_info'">
          <img src="assets/icones/info.svg" alt="" />
          <h3>{{ "companies.filter.groups.company_info" | translate }}</h3>
        </div>
        <div class="filters">
          <div class="filter" *ngIf="filter.companiesInfoFilter.name">
            <span>
              {{ "companies.filter.fields.name" | translate }} :
              {{ filter.companiesInfoFilter.name }}
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="filter.companiesInfoFilter.name = undefined"
            />
          </div>
          <div
            class="filter"
            *ngIf="
              filter.companiesInfoFilter.nbr_locations_min || filter.companiesInfoFilter.nbr_locations_max
            "
          >
            <span>
              {{
                "companies.filter.fields.nbr_locations" | translate
              }} :
              <ng-container *ngIf="filter.companiesInfoFilter.nbr_locations_min">
                {{ "common.from" | translate }}
                {{ filter.companiesInfoFilter.nbr_locations_min }}
              </ng-container>
              <ng-container *ngIf="filter.companiesInfoFilter.nbr_locations_max">
                {{ "common.to" | translate }}
                {{ filter.companiesInfoFilter.nbr_locations_max }}
              </ng-container>
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                filter.companiesInfoFilter.nbr_locations_min = undefined;
                filter.companiesInfoFilter.nbr_locations_max = undefined
              "
            />
          </div>
          <div
            class="filter"
            *ngIf="
              filter.companiesInfoFilter.total_sales_min || filter.companiesInfoFilter.total_sales_max
            "
          >
            <span>
              {{
                "companies.total_sales" | translate
              }} :
              <ng-container *ngIf="filter.companiesInfoFilter.total_sales_min">
                {{ "common.from" | translate }}
                {{ filter.companiesInfoFilter.total_sales_min }} €
              </ng-container>
              <ng-container *ngIf="filter.companiesInfoFilter.total_sales_max">
                {{ "common.to" | translate }}
                {{ filter.companiesInfoFilter.total_sales_max }} €
              </ng-container>
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                filter.companiesInfoFilter.total_sales_min = undefined;
                filter.companiesInfoFilter.total_sales_max = undefined
              "
            />
          </div>
          <div
            class="filter"
            *ngIf="
              filter.companiesInfoFilter.total_orders_min || filter.companiesInfoFilter.total_orders_max
            "
          >
            <span>
              {{
                "companies.total_orders" | translate
              }} :
              <ng-container *ngIf="filter.companiesInfoFilter.total_orders_min">
                {{ "common.from" | translate }}
                {{ filter.companiesInfoFilter.total_orders_min }} €
              </ng-container>
              <ng-container *ngIf="filter.companiesInfoFilter.total_orders_max">
                {{ "common.to" | translate }}
                {{ filter.companiesInfoFilter.total_orders_max }} €
              </ng-container>
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                filter.companiesInfoFilter.total_orders_min = undefined;
                filter.companiesInfoFilter.total_orders_max = undefined
              "
            />
          </div>
          <div
          class="filter"
          *ngIf="
            filter.companiesInfoFilter.active_from || filter.companiesInfoFilter.active_to
          "
        >
          <span>
            {{ "companies.filter.fields.not_active_since" | translate }} :
            <ng-container *ngIf="filter.companiesInfoFilter.active_from">
              {{ "common.from" | translate }}
              {{ filter.companiesInfoFilter.active_from }}
            </ng-container>
            <ng-container *ngIf="filter.companiesInfoFilter.active_to">
              {{ "common.to" | translate }}
              {{ filter.companiesInfoFilter.active_to }}
            </ng-container>
          </span>
          <img
            src="assets/icones/clear-filter.svg"
            alt=""
            (click)="
              filter.companiesInfoFilter.active_from= undefined;
              filter.companiesInfoFilter.active_to = undefined
            "
          />
        </div>
        </div>
      </div>
      <div
        class="filter-group"
        [class.filter-group-selected]="selectedGroup === 'location_info'"
      >
        <div class="group-title" (click)="selectedGroup = 'location_info'">
          <img src="assets/icones/inventory.svg" alt="" />
          <h3>{{ "companies.filter.groups.location_info" | translate }}</h3>
        </div>
        <div class="filters">
          <div class="filter" *ngIf="filter.locationInfoFilter.location_name">
            <span>
              {{ "companies.filter.fields.name" | translate }} :
              {{ filter.locationInfoFilter.location_name }}
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="filter.locationInfoFilter.location_name = undefined"
            />
          </div>

          <div
          class="filter"
          *ngIf="filter.locationInfoFilter.has_billing !== undefined"
        >
          <span>
            {{ "companies.filter.fields.has_billing_adress" | translate }} :
            {{
              (filter.locationInfoFilter.has_billing === true
                 ? "inventory.filter.values.yes"
                  : "inventory.filter.values.no"
              ) | translate
            }}
          </span>
          <img
            src="assets/icones/clear-filter.svg"
            alt=""
            (click)="filter.locationInfoFilter.has_billing  = undefined"
          />
        </div>
          <div
          class="filter"
          *ngIf="filter.locationInfoFilter.shipping_term !== undefined"
        >
          <span>
            {{ "companies.filter.fields.shipping_terms" | translate }} :
            {{
              (filter.locationInfoFilter.shipping_term === true
                  ? "inventory.filter.values.yes"
                  : "inventory.filter.values.no"
              ) | translate
            }}
          </span>
          <img
            src="assets/icones/clear-filter.svg"
            alt=""
            (click)="filter.locationInfoFilter.shipping_term = undefined"
          />
        </div>
        <div class="filter" *ngIf="filter.locationInfoFilter.payment_terms.length > 0">
          <span>
            {{ "companies.filter.fields.payment_terms" | translate }} :
            {{ getPaymentNames() }}
          </span>
          <img
            src="assets/icones/clear-filter.svg"
            alt=""
            (click)="filter.locationInfoFilter.payment_terms = [] "
          />
        </div>
        </div>
      </div>
      <div
      class="filter-group"
      [class.filter-group-selected]="selectedGroup === 'contact'"
    >
      <div class="group-title" (click)="selectedGroup = 'contact'">
        <img src="assets/icones/organize.svg" alt="" />
        <h3>{{ "companies.filter.groups.contact" | translate }}</h3>
      </div>
      <div class="filters">
        <div class="filter" *ngIf="filter.contactFilter.contact_name">
          <span>
            {{ "companies.filter.fields.name" | translate }} :
            {{ filter.contactFilter.contact_name }}
          </span>
          <img
            src="assets/icones/clear-filter.svg"
            alt=""
            (click)="filter.contactFilter.contact_name = undefined"
          />
        </div>
        <div
        class="filter"
        *ngIf="
          filter.contactFilter.nbr_contacts_min || filter.contactFilter.nbr_contacts_max
        "
      >
        <span>
          {{
            "companies.filter.fields.nbr_contacts" | translate
          }} :
          <ng-container *ngIf="filter.contactFilter.nbr_contacts_min">
            {{ "common.from" | translate }}
            {{ filter.contactFilter.nbr_contacts_min }}
          </ng-container>
          <ng-container *ngIf="filter.contactFilter.nbr_contacts_max">
            {{ "common.to" | translate }}
            {{ filter.contactFilter.nbr_contacts_max }}
          </ng-container>
        </span>
        <img
          src="assets/icones/clear-filter.svg"
          alt=""
          (click)="
            filter.contactFilter.nbr_contacts_min = undefined;
            filter.contactFilter.nbr_contacts_max = undefined
          "
        />
      </div>
        <div
        class="filter"
        *ngIf="
          filter.contactFilter.contacts_access_to_mktp_min || filter.contactFilter.contacts_access_to_mktp_max
        "
      >
        <span>
          {{
            "companies.filter.fields.contacts_access_to_mktp" | translate
          }} :
          <ng-container *ngIf="filter.contactFilter.contacts_access_to_mktp_min">
            {{ "common.from" | translate }}
            {{ filter.contactFilter.contacts_access_to_mktp_min }}
          </ng-container>
          <ng-container *ngIf="filter.contactFilter.contacts_access_to_mktp_max">
            {{ "common.to" | translate }}
            {{ filter.contactFilter.contacts_access_to_mktp_max }}
          </ng-container>
        </span>
        <img
          src="assets/icones/clear-filter.svg"
          alt=""
          (click)="
            filter.contactFilter.contacts_access_to_mktp_min = undefined;
            filter.contactFilter.contacts_access_to_mktp_max = undefined
          "
        />
      </div>
      </div>
    </div>
      <div
        *ngIf="!isLocation"
        class="filter-group"
        [class.filter-group-selected]="selectedGroup === 'organize'"
      >
        <div class="group-title" (click)="selectedGroup = 'organize'">
          <img src="assets/icones/organize.svg" alt="" />
          <h3>{{ "companies.filter.groups.organize" | translate }}</h3>
        </div>
        <div class="filters">
          <div
          class="filter"
          *ngIf="
            filter.organizeFilter.nbr_catalogs_min || filter.organizeFilter.nbr_catalogs_max
          "
        >
          <span>
            {{
              "companies.filter.fields.number_of_catalogs" | translate
            }} :
            <ng-container *ngIf="filter.organizeFilter.nbr_catalogs_min">
              {{ "common.from" | translate }}
              {{ filter.organizeFilter.nbr_catalogs_min }}
            </ng-container>
            <ng-container *ngIf="filter.organizeFilter.nbr_catalogs_max">
              {{ "common.to" | translate }}
              {{ filter.organizeFilter.nbr_catalogs_max }}
            </ng-container>
          </span>
          <img
            src="assets/icones/clear-filter.svg"
            alt=""
            (click)="
              filter.organizeFilter.nbr_catalogs_min = undefined;
              filter.organizeFilter.nbr_catalogs_max = undefined
            "
          />
        </div>
          <div
          class="filter"
          *ngIf="
            filter.organizeFilter.custom_discount_min || filter.organizeFilter.custom_discount_max
          "
        >
          <span>
            {{
              "companies.filter.fields.custom_discount" | translate
            }} :
            <ng-container *ngIf="filter.organizeFilter.custom_discount_min">
              {{ "common.from" | translate }}
              {{ filter.organizeFilter.custom_discount_min }}
            </ng-container>
            <ng-container *ngIf="filter.organizeFilter.custom_discount_max">
              {{ "common.to" | translate }}
              {{ filter.organizeFilter.custom_discount_max }}
            </ng-container>
          </span>
          <img
            src="assets/icones/clear-filter.svg"
            alt=""
            (click)="
              filter.organizeFilter.custom_discount_min = undefined;
              filter.organizeFilter.custom_discount_max = undefined
            "
          />
        </div>
        <div class="filter" *ngIf="filter.organizeFilter.fav_brands.length > 0">
          <span>
            {{ "companies.filter.fields.fav_brands" | translate }} :
            {{ getBrandsNames() }}
          </span>
          <img
            src="assets/icones/clear-filter.svg"
            alt=""
            (click)="filter.organizeFilter.fav_brands = []"
          />
        </div>
        <div class="filter" *ngIf="filter.organizeFilter.fav_categories.length > 0">
          <span>
            {{ "companies.filter.fields.fav_categories" | translate }} :
            {{ getCategoriesNames() }}
          </span>
          <img
            src="assets/icones/clear-filter.svg"
            alt=""
            (click)="filter.organizeFilter.fav_categories = []"
          />
        </div>
        <div class="filter" *ngIf="filter.organizeFilter.groups.length > 0">
          <span>
            {{ "companies.filter.fields.groups" | translate }} :
            {{ getGroupsNames()}}
          </span>
          <img
            src="assets/icones/clear-filter.svg"
            alt=""
            (click)="filter.organizeFilter.groups = []"
          />
        </div>
        </div>
      </div>
    </div>
    <div class="form">
      <ng-container *ngIf="selectedGroup === 'company_info' && !isLocation">
        <div class="form-title">
          <img src="assets/icones/info.svg" alt="" />
          <h3>{{ "companies.filter.groups." + selectedGroup | translate }}</h3>
        </div>

        <div class="inputs">

          <div class="field">
            <label for="deleted_show">{{
              "companies.filter.fields.show" | translate
            }}</label>
            <select
              id="deleted_show"
              [(ngModel)]="filter.companiesInfoFilter.deleted"
            >
              <option value="false">{{ "common.active" | translate }}</option>
              <option value="true">{{ "common.archived" | translate }}</option>
              <option value="all">{{ "common.all" | translate }}</option>
            </select>
          </div>

          <div class="field">
            <label for="name">{{
              "companies.filter.fields.name" | translate
            }}</label>
            <input
              id="name"
              type="text"
              [(ngModel)]="filter.companiesInfoFilter.name"
              [placeholder]="'companies.filter.fields.name' | translate"
            />
          </div>
          <div class="inputs-pair">
            <div class="field">
              <label for="nbr_locations_min">{{
                "companies.filter.fields.nbr_locations_min" | translate
              }}</label>
              <input
                id="nbr_locations_min"
                type="number"
                min="0"
                [max]="filter.companiesInfoFilter.nbr_locations_max || 1"
                [(ngModel)]="filter.companiesInfoFilter.nbr_locations_min"
                [placeholder]="
                  'companies.filter.fields.nbr_locations_min' | translate
                "
              />
            </div>
            <div class="field">
              <label for="nbr_locations_max">{{
                "companies.filter.fields.nbr_locations_max" | translate
              }}</label>
              <input
                id="nbr_locations_max"
                type="number"
                [min]="filter.companiesInfoFilter.nbr_locations_min|| 0"
                [(ngModel)]="filter.companiesInfoFilter.nbr_locations_max"
                [placeholder]="
                  'companies.filter.fields.nbr_locations_max' | translate
                "
              />
            </div>
          </div>
          <div class="inputs-pair">
            <div class="field">
              <label for="total_sales_min">{{
                "companies.filter.fields.total_sales_min" | translate
              }}</label>
              <input
                id="total_sales_min"
                type="number"
                min="0"
                [max]="filter.companiesInfoFilter.total_sales_max || 1"
                [(ngModel)]="filter.companiesInfoFilter.total_sales_min"
                [placeholder]="
                  'companies.filter.fields.total_sales_min' | translate
                "
              />
            </div>
            <div class="field">
              <label for="total_sales_max">{{
                "companies.filter.fields.total_sales_max" | translate
              }}</label>
              <input
                id="total_sales_max"
                type="number"
                [min]="filter.companiesInfoFilter.total_sales_min || 0"
                [(ngModel)]="filter.companiesInfoFilter.total_sales_max"
                [placeholder]="
                  'companies.filter.fields.total_sales_max' | translate
                "
              />
            </div>
          </div>
          <div class="inputs-pair">
            <div class="field">
              <label for="total_orders_min">{{
                "companies.filter.fields.total_orders_min" | translate
              }}</label>
              <input
                id="total_orders_min"
                type="number"
                min="0"
                [max]="filter.companiesInfoFilter.total_orders_max || 1"
                [(ngModel)]="filter.companiesInfoFilter.total_orders_min"
                [placeholder]="
                  'companies.filter.fields.total_orders_min' | translate
                "
              />
            </div>
            <div class="field">
              <label for="total_orders_max">{{
                "companies.filter.fields.total_orders_max" | translate
              }}</label>
              <input
                id="total_orders_max"
                type="number"
                [min]="filter.companiesInfoFilter.total_orders_min || 0"
                [(ngModel)]="filter.companiesInfoFilter.total_orders_max"
                [placeholder]="
                  'companies.filter.fields.total_orders_max' | translate
                "
              />
            </div>
          </div>
          <div class="inputs-pair">
            <div class="field">
              <label for="active_from">{{
                "companies.filter.fields.not_active_since" | translate
              }}</label>
                  <input
                  id="active_from"
                  type="date"
                  [(ngModel)]="filter.companiesInfoFilter.active_from"
                  [placeholder]="'companies.filter.fields.not_active_since' | translate"
                  />
            </div>
            <div class="field">
              <label for="active_to">{{
                "companies.filter.fields.not_active_since" | translate
              }}</label>
                <input
                id="active_to"
                type="date"
                [(ngModel)]="filter.companiesInfoFilter.active_to"
                [placeholder]="'companies.filter.fields.not_active_since' | translate"
                />
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="selectedGroup === 'location_info'">
        <div class="form-title">
          <img src="assets/icones/inventory.svg" alt="" />
          <h3>{{ "companies.filter.groups." + selectedGroup | translate }}</h3>
        </div>
        <div class="inputs">
          <div class="field">
            <label for="location_name">{{
              "companies.filter.fields.name" | translate
            }}</label>
            <input
              id="location_name"
              type="text"
              [(ngModel)]="filter.locationInfoFilter.location_name"
              [placeholder]="'companies.filter.fields.name' | translate"
            />
          </div>
          <div class="field equality_field">
            <label for="">{{ "companies.filter.fields.has_billing_adress" | translate }}</label>
            <select [(ngModel)]="filter.locationInfoFilter.has_billing">
              <option value="" disabled selected>
                {{ "companies.filter.fields.has_billing_adress" | translate }}
              </option>
              <option [ngValue]="true">
                {{ "inventory.filter.values.yes" | translate }}
              </option>
              <option [ngValue]="false">
                {{ "inventory.filter.values.no" | translate }}
              </option>
            </select>
          </div>
          <div class="field">
            <label for="">{{
              "companies.filter.fields.shipping_terms" | translate
              }}</label>
            <select [(ngModel)]="filter.locationInfoFilter.shipping_term">
              <option value="" disabled selected>
                {{ "companies.filter.fields.shipping_terms" | translate }}
              </option>
              <option [ngValue]="true">
                {{ "inventory.filter.values.yes" | translate }}
              </option>
              <option [ngValue]="false">
                {{ "inventory.filter.values.no" | translate }}
              </option>
            </select>
          </div>
          <div class="field">
            <div class="field equality_field">
              <label for="">{{
                "companies.filter.fields.payment_terms" | translate
              }}</label>
              <mat-chip-list #paymentsChipList>
                <mat-chip
                  *ngFor="
                    let payment of filter.locationInfoFilter.payment_terms;
                    index as i
                  "
                  (removed)="filter.locationInfoFilter.payment_terms.splice(i, 1)"
                >
                  {{ payment.name }}
                  <button matChipRemove>
                    <mat-icon style="color: #868e96">cancel</mat-icon>
                  </button>
                </mat-chip>
                <input
                  class="input_chip"
                  [placeholder]="'companies.filter.fields.payment_terms' | translate"
                  #fruitInput
                  (input)="filterPayment()"
                  [(ngModel)]="paymentFilterKey"
                  [ngModelOptions]="{ standalone: true }"
                  [matAutocomplete]="paymentsAutoComplete"
                  [matChipInputFor]="paymentsChipList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                />
              </mat-chip-list>
              <mat-autocomplete (optionSelected)="selectOption('payment', $event)" #paymentsAutoComplete="matAutocomplete">
                <ng-container *ngIf="filteredPayments$ | async as payments">
                  <mat-option
                    *ngFor="let payment of payments"
                    [value]="payment"
                  >
                    {{ payment.name }}
                  </mat-option>
                </ng-container>
              </mat-autocomplete>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="selectedGroup === 'contact'">
        <div class="form-title">
          <img src="assets/icones/contact.svg" alt="" />
          <h3>{{ "companies.filter.groups." + selectedGroup | translate }}</h3>
        </div>
        <div class="inputs">
          <div class="field">
            <label for="contact_name">{{
              "companies.filter.fields.name" | translate
            }}</label>
            <input
              id="contact_name"
              type="text"
              [(ngModel)]="filter.contactFilter.contact_name"
              [placeholder]="'companies.filter.fields.name' | translate"
            />
          </div>
          <div class="inputs-pair">
            <div class="field">
              <label for="nbr_contacts_min">{{
                "companies.filter.fields.nbr_contacts_min" | translate
              }}</label>
              <input
                id="nbr_contacts_min"
                type="number"
                min="0"
                [max]="filter.contactFilter.nbr_contacts_max || 1"
                [(ngModel)]="filter.contactFilter.nbr_contacts_min"
                [placeholder]="
                  'companies.filter.fields.nbr_contacts_min' | translate
                "
              />
            </div>
            <div class="field">
              <label for="nbr_contacts_max">{{
                "companies.filter.fields.nbr_contacts_max" | translate
              }}</label>
              <input
                id="nbr_contacts_max"
                type="number"
                [min]="filter.contactFilter.nbr_contacts_min || 0"
                [(ngModel)]="filter.contactFilter.nbr_contacts_max"
                [placeholder]="
                  'companies.filter.fields.nbr_contacts_max' | translate
                "
              />
            </div>
          </div>
          <div class="inputs-pair">
            <div class="field">
              <label for="contacts_access_to_mktp_min">{{
                "companies.filter.fields.contacts_access_to_mktp_min" | translate
              }}</label>
              <input
                id="contacts_access_to_mktp_min"
                type="number"
                min="0"
                [max]="filter.contactFilter.contacts_access_to_mktp_max || 1"
                [(ngModel)]="filter.contactFilter.contacts_access_to_mktp_min"
                [placeholder]="
                  'companies.filter.fields.contacts_access_to_mktp_min' | translate
                "
              />
            </div>
            <div class="field">
              <label for="contacts_access_to_mktp_max">{{
                "companies.filter.fields.contacts_access_to_mktp_max" | translate
              }}</label>
              <input
                id="contacts_access_to_mktp_max"
                type="number"
                [min]="filter.contactFilter.contacts_access_to_mktp_min || 0"
                [(ngModel)]="filter.contactFilter.contacts_access_to_mktp_max"
                [placeholder]="
                  'companies.filter.fields.contacts_access_to_mktp_max' | translate
                "
              />
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="selectedGroup === 'organize' && !isLocation">
        <div class="form-title">
          <img src="assets/icones/organize.svg" alt="" />
          <h3>{{ "companies.filter.groups." + selectedGroup | translate }}</h3>
        </div>
        <div class="inputs">
          <div class="inputs-pair">
            <div class="field">
              <label for="number_of_catalogs_min">{{
                "companies.filter.fields.number_of_catalogs_min" | translate
              }}</label>
              <input
                id="nbr_catalogs_min"
                type="number"
                min="0"
                [max]="filter.organizeFilter.nbr_catalogs_max || 1"
                [(ngModel)]="filter.organizeFilter.nbr_catalogs_min"
                [placeholder]="
                  'companies.filter.fields.number_of_catalogs_min' | translate
                "
              />
            </div>
            <div class="field">
              <label for="number_of_catalogs_max">{{
                "companies.filter.fields.number_of_catalogs_max" | translate
              }}</label>
              <input
                id="nbr_catalogs_max"
                type="number"
                [min]="filter.organizeFilter.nbr_catalogs_min || 0"
                [(ngModel)]="filter.organizeFilter.nbr_catalogs_max"
                [placeholder]="
                  'companies.filter.fields.number_of_catalogs_max' | translate
                "
              />
            </div>
          </div>
          <div class="inputs-pair">
            <div class="field">
              <label for="custom_discount_min">{{
                "companies.filter.fields.custom_discount_min" | translate
              }}</label>
              <input
                id="custom_discount_min"
                type="number"
                min="0"
                [max]="filter.organizeFilter.custom_discount_max || 1"
                [(ngModel)]="filter.organizeFilter.custom_discount_min"
                [placeholder]="
                  'companies.filter.fields.custom_discount_min' | translate
                "
              />
            </div>
            <div class="field">
              <label for="custom_discount_max">{{
                "companies.filter.fields.custom_discount_max" | translate
              }}</label>
              <input
                id="custom_discount_max"
                type="number"
                [min]="filter.organizeFilter.custom_discount_min || 0"
                [(ngModel)]="filter.organizeFilter.custom_discount_max"
                [placeholder]="
                  'companies.filter.fields.custom_discount_max' | translate
                "
              />
            </div>
          </div>

          <div class="inputs-pair">
            <div class="field">
              <div class="field equality_field">
                <label for="">{{
                  "companies.filter.fields.fav_brands" | translate
                }}</label>
                <mat-chip-list #brandsChipList>
                  <mat-chip
                    *ngFor="let brand of filter.organizeFilter.fav_brands; index as i"
                    (removed)="filter.organizeFilter.fav_brands.splice(i, 1)"
                  >
                    {{ brand.name }}
                    <button matChipRemove>
                      <mat-icon style="color: #868e96">cancel</mat-icon>
                    </button>
                  </mat-chip>
                  <input
                    class="input_chip"
                    [placeholder]="'companies.filter.fields.fav_brands' | translate"
                    #fruitInput
                    (input)="filterBrands()"
                    [(ngModel)]="brandsFilterKey"
                    [ngModelOptions]="{ standalone: true }"
                    [matAutocomplete]="brandsAutoComplete"
                    [matChipInputFor]="brandsChipList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  />
                </mat-chip-list>
                <mat-autocomplete (optionSelected)="selectOption('brand', $event)" #brandsAutoComplete="matAutocomplete">
                  <ng-container *ngIf="filteredBrands$ | async as brands">
                    <mat-option
                      *ngFor="let brand of brands"
                      [value]="brand"
                    >
                      {{ brand.name }}
                    </mat-option>
                  </ng-container>
                </mat-autocomplete>
              </div>
            </div>
            <div class="field">
              <div class="field equality_field">
                <label for="">{{
                  "companies.filter.fields.fav_categories" | translate
                }}</label>
                <mat-chip-list #categoriesChipList>
                  <mat-chip
                    *ngFor="let category of filter.organizeFilter.fav_categories; index as i"
                    (removed)="filter.organizeFilter.fav_categories.splice(i, 1)"
                  >
                    {{ category.name }}
                    <button matChipRemove>
                      <mat-icon style="color: #868e96">cancel</mat-icon>
                    </button>
                  </mat-chip>
                  <input
                    class="input_chip"
                    [placeholder]="'companies.filter.fields.fav_categories' | translate"
                    #fruitInput
                    (input)="filterCategories()"
                    [(ngModel)]="categoriesFilterKey"
                    [ngModelOptions]="{ standalone: true }"
                    [matAutocomplete]="categoriesAutoComplete"
                    [matChipInputFor]="categoriesChipList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  />
                </mat-chip-list>
                <mat-autocomplete (optionSelected)="selectOption('category', $event)" #categoriesAutoComplete="matAutocomplete">
                  <ng-container *ngIf="filteredCategories$ | async as categories">
                    <mat-option
                      *ngFor="let category of categories"
                      [value]="category"
                    >
                      {{ category.name }}
                    </mat-option>
                  </ng-container>
                </mat-autocomplete>
              </div>
            </div>
          </div>
          <div class="inputs-pair">
            <div class="field">
              <div class="field equality_field">
                <label for="">{{
                  "companies.filter.fields.groups" | translate
                }}</label>
                <mat-chip-list #groupsChipList>
                  <mat-chip
                    *ngFor="let group of filter.organizeFilter.groups; index as i"
                    (removed)="filter.organizeFilter.groups.splice(i, 1)"
                  >
                    {{ group.name }}
                    <button matChipRemove>
                      <mat-icon style="color: #868e96">cancel</mat-icon>
                    </button>
                  </mat-chip>
                  <input
                    class="input_chip"
                    [placeholder]="'companies.filter.fields.groups' | translate"
                    #fruitInput
                    (input)="filterGroups()"
                    [(ngModel)]="groupsFilterKey"
                    [ngModelOptions]="{ standalone: true }"
                    [matAutocomplete]="groupsAutoComplete"
                    [matChipInputFor]="groupsChipList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  />
                </mat-chip-list>
                <mat-autocomplete (optionSelected)="selectOption('group', $event)" #groupsAutoComplete="matAutocomplete">
                  <ng-container *ngIf="filteredGroups$ | async as groups">
                    <mat-option
                      *ngFor="let group of groups"
                      [value]="group"
                    >
                      {{ group.name }}
                    </mat-option>
                  </ng-container>
                </mat-autocomplete>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="footer submet_btns">
    <button class="save_btn_pop_up cancel_btn_pop_up" (click)="close()">
        <span>{{"common.cancel"|translate | uppercase}}</span>
        <img src="../../../../../assets/icones/arrow_back.svg" alt="">
    </button>
    <div class="save-apply">
      <div class="save-filter-form" *ngIf="toggleSaveFilterForm && getFiltersCount() > 0">
        <div class="label-action">
          <label for="filter_name">{{
            "filter.filter_name" | translate
          }}</label>
          <div class="actions">
            <button class="cancel-btn" (click)="toggleSaveFilter()">{{ "common.cancel" | translate }}</button>
            <button class="save-btn" (click)="save()">
              {{ "common.save" | translate | uppercase }}
            </button>
          </div>
        </div>
        <input
          id="filter_name"
          type="text"
          class="filter-name-input"
          [placeholder]="'filter.filter_name' | translate"
          [(ngModel)]="filterName"
          [formControl]="filterNameControl"
        />
        <span class="error_ms" *ngIf="filterNameControl?.touched && filterNameControl?.errors">
          {{ "common.required_field" | translate }}
        </span>
      </div>
      <button
        class="save save_filter"
        [disabled]="getFiltersCount() <= 0" *ngIf="!toggleSaveFilterForm"
        (click)="toggleSaveFilter()"
      >
        <img src="assets/icones/save-filter.svg" alt="" />
        <small>{{ "filter.save" | translate }}</small>
      </button>
      <button class="save_btn_pop_up blue_btn" (click)="apply()">
        <small>{{ "filter.apply" | translate | uppercase }}</small>
        <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
      </button>
    </div>
  </div>
</div>
